export enum UserRole {
    TRADER = 'ROLE_TRADER',
    OPERATOR = 'ROLE_OPERATOR',
    MERCHANT = 'ROLE_MERCHANT',
    MERCHANT_OPERATOR = 'ROLE_MERCHANT_OPERATOR',
    TRADER_OPERATOR = 'ROLE_TRADER_OPERATOR',
    ADMIN = 'ROLE_ADMIN',
    TRADER_TEAM_LEAD = 'ROLE_TRADER_TEAM_LEAD',
    REFERRAL = 'ROLE_REFERRAL',
}